// @flow

export const SET_AVAILABLE_FILTER_ENTITIES = 'SET_AVAILABLE_FILTER_ENTITIES'
export const SET_PRODUCT_CONFIGURATIONS = 'SET_PRODUCT_CONFIGURATIONS'
export const SET_DATE_EFFECTIVE = 'SET_DATE_EFFECTIVE'
export const SET_SELECTED_CUSTOMER_GROUP = 'SET_SELECTED_CUSTOMER_GROUP'
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT'
export const SET_SELECTED_TERM = 'SET_SELECTED_TERM'
export const SET_SELECTED_FROM_STOP = 'SET_SELECTED_FROM_STOP'
export const SET_PRE_SELECTED_FROM_STOP_ID = 'SET_PRE_SELECTED_FROM_STOP_ID'
export const SET_SELECTED_TO_STOP = 'SET_SELECTED_TO_STOP'
export const SET_PRE_SELECTED_TO_STOP_ID = 'SET_PRE_SELECTED_TO_STOP_ID'
export const SET_SELECTED_CLASS = 'SET_SELECTED_CLASS'
export const SET_PRE_SELECTED_CLASS_ID = 'SET_PRE_SELECTED_CLASS_ID'
export const SET_SELECTED_STAR_VALUE = 'SET_SELECTED_STAR_VALUE'
export const SET_PRE_SELECTED_STAR_VALUE_ID = 'SET_PRE_SELECTED_STAR_VALUE_ID'
export const SET_SELECTED_ZONE = 'SET_SELECTED_ZONE'
export const SET_PRE_SELECTED_ZONE_ID = 'SET_PRE_SELECTED_ZONE_ID'
export const SET_PRE_SELECTED_ZONE_CODE = 'SET_PRE_SELECTED_ZONE_CODE'
export const SET_ENGRAVED_ID = 'SET_ENGRAVED_ID'
export const SET_COVERED_PERIOD = 'SET_COVERED_PERIOD'
export const SET_EXPIRY_REMINDER = 'SET_EXPIRY_REMINDER'
export const SET_RENEW_SUBSCRIPTION_ID = 'SET_RENEW_SUBSCRIPTION_ID'
export const SET_SPECIAL_SALE_SLUG = 'SET_SPECIAL_SALE_SLUG'
export const RESET = 'RESET'
export const SET_SESSION_ID = 'SET_SESSION_ID'

export default {
  SET_AVAILABLE_FILTER_ENTITIES,
  SET_PRODUCT_CONFIGURATIONS,
  SET_DATE_EFFECTIVE,
  SET_SELECTED_CUSTOMER_GROUP,
  SET_SELECTED_PRODUCT,
  SET_SELECTED_TERM,
  SET_SELECTED_FROM_STOP,
  SET_PRE_SELECTED_FROM_STOP_ID,
  SET_SELECTED_TO_STOP,
  SET_PRE_SELECTED_TO_STOP_ID,
  SET_SELECTED_CLASS,
  SET_PRE_SELECTED_CLASS_ID,
  SET_SELECTED_STAR_VALUE,
  SET_PRE_SELECTED_STAR_VALUE_ID,
  SET_SELECTED_ZONE,
  SET_PRE_SELECTED_ZONE_ID,
  SET_PRE_SELECTED_ZONE_CODE,
  SET_ENGRAVED_ID,
  SET_COVERED_PERIOD,
  SET_EXPIRY_REMINDER,
  SET_SPECIAL_SALE_SLUG,
  SET_RENEW_SUBSCRIPTION_ID,
  RESET,
  SET_SESSION_ID
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration/mutation-types.js